import * as React from 'react';
import Axios from 'axios';
import { Redirect } from 'react-router';
import '../../genericComponents/Button/LoaderButton.css';

interface State {
    NewPassword: string;
    Passwordconfirmed: string;
    GoodNewPassword: boolean;
    Valid: boolean;
    Redirect: boolean;
}

interface Props {
    token: string;
}

/**
 * Ce composant permet de changer de mot de passe.
 * Il prend en paramétre une string qui correspond à un token.
 */
export class ChangePasswordForm extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
        this.state = {
            Passwordconfirmed: '',
            NewPassword: '',
            GoodNewPassword: true,
            Valid: true,
            Redirect: false,
        };
    }

    handleConfirmation = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (this.state.NewPassword === this.state.Passwordconfirmed && this.state.NewPassword.length >= 8) {
            Axios.post(
                process.env.REACT_APP_RESET_PASSWORD_TOKEN_URL!,
                {
                    token: this.props.token,
                    password: this.state.NewPassword,
                }
            ).then(
                () => {
                    this.setState({Redirect: true});
                }
            ).catch(
                (error) => {
                    alert(JSON.stringify(error));
                }
            );
        }
    }

    render() {
        if (this.state.Redirect) {
            return (<Redirect to="/" />);
        }
        return (
            <div className="col-12">
                <div className="form-group">
                    <input
                        className="form-control"
                        placeholder="Nouveau mot de passe"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            if (e.target.value.length >= 8) {
                                this.setState({ NewPassword: e.target.value, GoodNewPassword: true });
                            } else {
                                this.setState({ NewPassword: e.target.value });
                            }
                        }}
                        onBlur={
                            () => {
                                if (this.state.NewPassword.length < 8) {
                                    this.setState({ GoodNewPassword: false });
                                }
                            }
                        }
                        value={this.state.NewPassword}
                        name="password"
                        type="password"
                        style={this.state.GoodNewPassword ? {} : { borderColor: 'red' }}
                    />
                    {this.getHelpPassword()}
                </div>
                <div className="form-group">
                    <input
                        className="form-control"
                        placeholder="Confirmation de mot de passe"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            if (e.target.value === this.state.NewPassword) {
                                this.setState({ Passwordconfirmed: e.target.value, Valid: true });
                            } else {
                                this.setState({ Passwordconfirmed: e.target.value });
                            }
                        }}
                        onBlur={
                            () => {
                                if (this.state.Passwordconfirmed !== this.state.NewPassword) {
                                    this.setState({ Valid: false });
                                }
                            }
                        }
                        value={this.state.Passwordconfirmed}
                        name="password"
                        type="password"
                        style={this.state.Valid ? {} : { borderColor: 'red' }}
                    />
                    {this.getHelpConfirmation()}
                </div>
                <button
                    className={this.getButtonClass()}
                    onClick={this.handleConfirmation}
                >
                    Validation
                </button>
            </div>
        );
    }

    private getHelpPassword = () => {
        if (!this.state.GoodNewPassword) {
            return (
                <small
                    id="passwordHelpBlock"
                    className="form-text text-danger"
                >
                    Le mot de passe doit contenir au moins 8 caractères
                </small>
            );
        }
        return;
    }

    private getHelpConfirmation = () => {
        if (!this.state.Valid) {
            return (

                <small
                    id="passwordHelpBlock"
                    className="form-text text-danger"
                >
                    Le mot de passe et sa confirmation ne correspondent pas
                </small>
            );
        }
        return;
    }

    private getButtonClass = () => {
        if (this.state.NewPassword === this.state.Passwordconfirmed && this.state.NewPassword.length >= 8) {
            return 'btn btn-lg col-12';
        } else {
            return 'btn btn-lg col-12 disabled';
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/LoginPage/internalComponents/ChangePasswordForm.tsx